
import { ArrowLeft, Search, Sparkles } from "lucide-react";
import { useAssistantActions } from "@/components/assistant/assistant-provider";
import { usePathname, useRouter } from "@/lib/router-compat";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useCurrentPageTitle } from "@/hooks/usePageTitle";

interface MobileTopBarProps {
  orgInitial?: string;
  onProfileOpen: () => void;
  onSearchOpen?: () => void;
}

export function MobileTopBar({ orgInitial, onProfileOpen, onSearchOpen }: MobileTopBarProps) {
  const pathname = usePathname();
  const router = useRouter();
  const title = useCurrentPageTitle();
  const assistantActions = useAssistantActions();
  const isRoot = pathname === "/dashboard";

  return (
    <div className="sticky top-0 z-30 flex h-[var(--mobile-top-bar-height)] lg:hidden items-center border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 px-2 gap-1 shrink-0 app-safe-top">
      {!isRoot && (
        <button
          onClick={() => router.back()}
          aria-label="Back"
          className="shrink-0 flex h-10 w-10 items-center justify-center rounded-md text-foreground hover:bg-accent motion-safe:active:scale-95 motion-safe:transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
      )}

      <h1 className="flex-1 min-w-0 truncate text-base font-semibold px-1">
        {title}
      </h1>

      {assistantActions && (
        <button
          onClick={() => assistantActions.openAssistant()}
          aria-label="Ask AI"
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
        >
          <Sparkles className="h-5 w-5" />
        </button>
      )}

      {onSearchOpen && (
        <button
          onClick={onSearchOpen}
          aria-label="Search"
          className="shrink-0 flex h-10 w-10 items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
        >
          <Search className="h-5 w-5" />
        </button>
      )}

      <button
        onClick={onProfileOpen}
        aria-label="Profile menu"
        className="shrink-0 flex h-10 w-10 items-center justify-center rounded-md motion-safe:active:scale-95 motion-safe:transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Avatar className="h-8 w-8">
          <AvatarFallback className="text-xs">{orgInitial ?? "?"}</AvatarFallback>
        </Avatar>
      </button>
    </div>
  );
}
